/* eslint-disable arrow-parens */
/* eslint-disable react/prop-types */
import { useCallback } from "react";
import { Checkbox, FormControlLabel, Grid, TextField } from "@mui/material";
import InputMask from "react-input-mask";

import "./gliGrid.css";
import { BeneficiaryGridProps, CommonBeneficiaryProps } from "../../../../../../../types/gliForm.types";

// interface CommonBeneficiaryProps {
// 	id: number;
// 	name: string;
// 	date_of_birth: string;
// 	relationship: string;
// 	SSN: string;
// 	address: string;
// 	percentage: string;
// 	type: string;
// }

// interface BeneficiaryGridProps {
// 	isPrintable: boolean;
// 	beneficiary: CommonBeneficiaryProps[];
// 	handleAddBeneficiary: (beneficiaries: CommonBeneficiaryProps[]) => Promise<void>;
// 	id: number;
// 	index: number;
// }

// eslint-disable-next-line react/prop-types
const GliGrid = ({ isPrintable, beneficiary, handleAddBeneficiary, id, index }: BeneficiaryGridProps) => {
	console.log("check===>", beneficiary);
	// console.log("check===>2", handleAddBeneficiary);
	// console.log("check===>3", id);
	// console.log("check===>4", index);
	const handleBeneficieryDetailsChange = useCallback(
		(event) => {
			const { name, value } = event.target;
			if (name === "date_of_birth") {
				const _value = value.split("/");
				console.log("Value", _value);
				if (_value.length === 2 && !_value[1]) {
					if (parseInt(value) > 12) {
						alert("Invalid month. Valid format mm/dd/yyyy");
						event.target.value = "";
						return;
					}
				} else if (_value.length === 3 && _value[1] !== "") {
					console.log(parseInt(value));
					if (
						(parseInt(_value[1]) > 30 && parseInt(_value[0]) % 2 !== 0) ||
						(parseInt(_value[1]) > 31 && parseInt(_value[0]) % 2 === 0)
					) {
						alert("Invalid date. Valid format mm/dd/yyyy");
						event.target.value = _value[0];
						return;
					}
				}
			}
			if (name === "address" && value.length > 20) {
				return;
			}

			if (beneficiary[index].id === id) {
				console.log("beneficiary[index].id", beneficiary[index].id);
				const _beneficiery = beneficiary;

				_beneficiery[index] = Object.assign({}, beneficiary[index], { [name]: value });

				handleAddBeneficiary(Object.assign([], _beneficiery));
			}
		},
		[beneficiary, id, index, handleAddBeneficiary]
	);
	// const handleCheckboxChange = (type) => {
	// 	const updatedBeneficiery = [...beneficiary];

	// 	// Ensure only one is selected at a time
	// 	updatedBeneficiery[index] = {
	// 		...updatedBeneficiery[index],
	// 		type: type
	// 	};

	// 	handleAddBeneficiary(updatedBeneficiery);
	// };

	const handleCheckboxChange = (type: string) => {
		const updatedBeneficiery = [...beneficiary];

		// Ensure only one is selected at a time
		updatedBeneficiery[index] = { ...updatedBeneficiery[index], type };
		handleAddBeneficiary(updatedBeneficiery);
	};

	// console.log("Beneficiery", beneficiary);

	if (!beneficiary) return <></>;

	return (
		<Grid container spacing={1}>
			<Grid
				item
				xs={3}
				sm={3}
				md={3}
				lg={3}
				xl={3}
				className={isPrintable ? "gli-primary-benefit-header" : "gli-primary-benefit-header form-padding"}
			>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={isPrintable ? "" : "display-flex-row"}>
					<div className={isPrintable ? "name-field  font-size-medium" : "name-field  font-size-large"}>
						<b>Name</b>
					</div>
					{isPrintable ? (
						""
					) : (
						<TextField
							className="name-input-field "
							variant="outlined"
							name="name"
							onChange={handleBeneficieryDetailsChange}
						/>
					)}
				</Grid>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={isPrintable ? "" : "display-flex-row"}>
					<div className={isPrintable ? "address-field  font-size-medium" : "address-field  font-size-large"}>
						<b>Address</b>
					</div>
					{isPrintable ? (
						""
					) : (
						<TextField
							className="address-input-field "
							variant="outlined"
							onChange={handleBeneficieryDetailsChange}
							name="address"
							value={beneficiary[index]?.address}
						/>
					)}
				</Grid>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={isPrintable ? "gli-primary-benefit-header2" : "gli-primary-benefit-header2 form-padding"}
			>
				<div className="phone-container">
					{isPrintable ? (
						""
					) : (
						<InputMask
							mask="999-99-9999"
							maskChar=""
							disabled={false}
							value={beneficiary[index]?.SSN}
							onChange={handleBeneficieryDetailsChange}
						>
							{() => (
								<TextField
									className="phone-input-field input-field-margin-2"
									variant="outlined"
									placeholder="XXX-XX-XX"
									name="SSN"
									// value={beneficiary[index]?.SSN}
									// onChange={handleBeneficieryDetailsChange}
								/>
							)}
						</InputMask>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={isPrintable ? "gli-primary-benefit-header3" : "gli-primary-benefit-header3 form-padding"}
			>
				<div className="personal-details-container">
					{isPrintable ? (
						""
					) : (
						<div className="select-dropdown">
							<select onChange={handleBeneficieryDetailsChange} name="relationship" defaultValue="">
								<option value="" disabled>
									{}
								</option>
								<option value="spouse" title="Spouse">
									Spouse
								</option>
								<option value="son">Son</option>
								<option value="daughter">Daughter</option>
								<option value="stepchild">Stepchild </option>
								<option value="court_ordered_dependent">Court Order Dependent</option>
								<option value="legal_custody_child">Legal Custody child</option>
								<option value="disabled_child">Disabled Child</option>
								<option value="GrandChild">Grandchild</option>
							</select>
						</div>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={isPrintable ? "gli-primary-benefit-header4" : "gli-primary-benefit-header4 form-padding"}
			>
				<div className="dob-value-container ">
					{isPrintable ? (
						""
					) : (
						<InputMask
							mask="99/99/9999"
							maskChar=""
							disabled={false}
							onChange={handleBeneficieryDetailsChange}
						>
							{() => (
								<TextField
									className="dob-input-field input-field-margin-2"
									variant="outlined"
									placeholder="MM/DD/YYYY"
									// onChange={handleBeneficieryDetailsChange}
									name="date_of_birth"
								/>
							)}
						</InputMask>
						// <TextField
						// 	className="dob-input-field input-field-margin-2"
						// 	variant="outlined"
						// 	placeholder="MM/DD/YYYY"
						// 	// onChange={handleBeneficieryDetailsChange}
						// 	name="date_of_birth"
						// />
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={1}
				sm={1}
				md={1}
				lg={1}
				xl={1}
				className={isPrintable ? "gli-primary-benefit-header5" : "gli-primary-benefit-header5 form-padding"}
			>
				<div className="percentage-value-container">
					{isPrintable ? (
						""
					) : (
						<TextField
							className="phone-input-field input-field-margin-2 "
							variant="outlined"
							onChange={handleBeneficieryDetailsChange}
							name="percentage"
						/>
					)}
				</div>
			</Grid>
			<Grid
				item
				xs={2}
				sm={2}
				md={2}
				lg={2}
				xl={2}
				className={isPrintable ? "gli-primary-benefit-header6" : "gli-primary-benefit-header6 form-padding"}
			>
				<FormControlLabel
					control={
						<Checkbox
							checked={beneficiary[index].type === "primary_beneficiery"}
							onChange={() => handleCheckboxChange("primary_beneficiery")}
						/>
					}
					label="Primary"
				/>
				<FormControlLabel
					control={
						<Checkbox
							checked={beneficiary[index].type === "contingent_beneficiery"}
							onChange={() => handleCheckboxChange("contingent_beneficiery")}
						/>
					}
					label="Contingent"
				/>
			</Grid>
		</Grid>
	);
};

export default GliGrid;
